import { GridFilterTypes } from "../../../grid";
import { getMaintainers } from "../../common/external-sources/Maintainers";
import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { EntryTypes } from "../../common/fields";
import { Modes } from "../../common/fields/mode";
import { SchemaContext } from "../../..";

export const createMaintenancePerformedBy = (context: SchemaContext): FieldSchema => ({
  name: "maintenancePerformedBy",
  data: { maxLength: 25 },
  display: {
    displayed: true,
  },
  form: {
    label: "Maintenance performed by",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
  grid: {
    displayed: true,
    order: 82,
    filter: GridFilterTypes.SET,
    filterValues: { getter: () => getMaintainers(context.client) },
  },
});

export default createMaintenancePerformedBy;
